import styled from "styled-components";

export const FormPageWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Form = styled.form`
    position: relative;
    width: 700px;
    height: 100%;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @media only screen and (max-width: 800px) {
        width: 100%;
        padding: 1rem;
    }
`;

export const IndicatorsWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-top: 1rem;
`;

export const Indicator = styled.div<{
    active: boolean;
}>`
    width: 15px;
    height: 15px;
    background-color: ${(props) => props.active ? "#808B96" : "#B2BABB"};
    border-radius: 50%;
    cursor: pointer;
`;

export const ButtonsWrapper = styled.div`
    position: fixed;
    width: 100%;
    bottom: 1rem;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
`;

export const ChangeTabButton = styled.button`
    border: none;
    background-color: rgba(172, 52, 33, 1);
    opacity: 0.8;
    padding: 0.5rem;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;

    &:hover {
        opacity: 1;
    }
`;